// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overlay {\n  background-color: var(--bluey-grey-50) !important;\n}\n.dropdown {\n  border: 1px solid var(--bluey-grey) !important;\n}\n.dropdown-item:hover {\n  color: #151515 !important;\n}\n", ""]);
// Exports
module.exports = exports;
